import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import { Typography } from '@material-ui/core';

import UserDetails from './components/UserDetails';
import { vimoCreateRoles } from '../../common/constants';

const styles = theme => ({
    root: {

    },
    roleDescriptions: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(3),
    },
    roleDescription: {
        marginBottom: theme.spacing(2),
        background: theme.palette.common.white,
        padding: theme.spacing(1),
    },
});

class NewUser extends React.Component {
    render() {
        const {
            classes, translate, profileData,
        } = this.props;

        if (!profileData || !profileData.selectedRole) {
            return null;
        }

        const showRoleDescriptions = false;

        return (
            <div className={classes.root}>
                <UserDetails userData={{ }} />

                {showRoleDescriptions && (
                    <div className={classes.roleDescriptions}>
                        <Typography variant="h6" gutterBottom>
                            {translate('user.roleDescriptions')}
                        </Typography>
                        {vimoCreateRoles.map(role => (
                            <div key={role} className={classes.roleDescription}>
                                <Typography variant="subtitle2">
                                    {translate(`user.appRoles_${role}`)}
                                </Typography>
                                <Typography>
                                    {translate(`user.appRoles_${role}_Description`)}
                                </Typography>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}


NewUser.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    profileData: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    profileData: state.auth.profileData,
    clientConfig: state.auth.clientConfig,
});

export default connect(mapStateToProps)(withStyles(styles)(NewUser));
